var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeAgentManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m417.927 343.755v27.138l-43.078 11.198c-2.414 7.912-5.585 15.503-9.424 22.688l22.571 38.395-38.395 38.395-38.366-22.572c-7.214 3.81-14.805 6.981-22.717 9.424l-11.197 43.079h-54.276l-11.199-43.078c-7.912-2.443-15.503-5.614-22.688-9.424l-38.395 22.572-38.395-38.395 22.571-38.366c-3.839-7.214-6.981-14.805-9.424-22.717l-43.078-11.198v-27.138h335.49z",
    fill: "#00baec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m331.074 343.755c0 44.648-36.213 80.862-80.891 80.862-44.648 0-80.862-36.213-80.862-80.862z",
    fill: "#00a7d4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m403.936.5-147.936 39.675v303.58h147.936z",
    fill: "#fd646f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m403.936.5-13.147 3.52v339.735h13.147z",
    fill: "#d4424c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288.461 75.37h30.483v30.425h-30.483zm52.502 0v30.425h30.512v-30.425zm-52.502 82.869h30.483v-30.425h-30.483zm52.502 0h30.512v-30.425h-30.512zm0 52.444h30.512v-30.425h-30.512zm-52.502 0h30.483v-30.425h-30.483z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m288.461 256.233h83.014v87.523h-83.014z",
    fill: "#eaf6ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m288.461 256.233h83.014v20.128h-83.014z",
    fill: "#b1dbfc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m256 105.388-147.965 39.703v198.664h147.965z",
    fill: "#eaf6ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m256 105.388-16.667 4.479v233.888h16.667z",
    fill: "#b1dbfc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m223.51 180.258v30.425h-82.985v-30.425zm-82.985 82.868h82.985v-30.425h-82.985zm0 52.444h82.985v-30.425h-82.985z",
    fill: "#00baec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.267 343.755c0 3.96-3.21 7.17-7.17 7.17h-388.194c-3.96 0-7.17-3.21-7.17-7.17s3.21-7.17 7.17-7.17h260.881v-62.522h14.369v62.522h112.945c3.959 0 7.169 3.21 7.169 7.17z",
    fill: "#b1dbfc"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m223.51 180.258v30.425h-30.367v-30.425zm-30.367 82.868h30.367v-30.425h-30.367zm0 52.444h30.367v-30.425h-30.367z",
    fill: "#00a7d4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAgentManagement);
export default __webpack_public_path__ + "static/media/office-agent-management.da0c1f812207f062265480fc5d90cf8e.svg";
export { ForwardRef as ReactComponent };